import {
  getFontCss,
  Popup,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import {
  selectDeletingExpenseFromState,
  selectDeletingExpenseTopLevelError,
} from 'src/app/UpdateExpenseFlyout/redux/updateExpense.selectors'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'
import { useTranslate } from 'src/localization/Trns'
import { createSetIsDeleteExpensePopupOpen } from 'src/redux/actions/app.actions'
import { deleteExpense } from 'src/redux/actions/data/expenses.actions'
import { selectSelectedDeleteExpensesFromState } from 'src/redux/selectors/data/expenses.selectors'
import { css } from 'styled-components'

const DeleteExpensePopup: React.FC = (): React.ReactElement => {
  const translate = useTranslate()

  const dispatch = useDispatch()
  const expenses = useSelector(selectSelectedDeleteExpensesFromState)
  const deletingExpense = useSelector(selectDeletingExpenseFromState)
  const topLevelError = useSelector(selectDeletingExpenseTopLevelError)
  const { analytics } = useAnalyticsContext()

  const subTitleTopText =
    expenses !== undefined &&
    (expenses.length === 1
      ? translate('You are about to delete 1 expense.')
      : translate('You are about to delete ${count} expenses.', {
          count: expenses.length.toString(),
        }))

  const dispatchDeleteExpense = (): void => {
    expenses !== undefined && dispatch(deleteExpense(expenses, analytics))
  }

  const closePopup = (): void => {
    dispatch(createSetIsDeleteExpensePopupOpen(false))
  }

  return (
    <Popup
      onClickClose={closePopup}
      showCloseButton
      css={`
        display: flex;
        flex-direction: column;
        position: relative;
      `}
    >
      <ConfirmationPopupContent
        title={translate('Delete Expense')}
        subtitle={
          <>
            <p
              css={css`
                margin-bottom: 20px;
              `}
            >
              {subTitleTopText}
            </p>
            <p
              css={css`
                ${getFontCss(
                  16,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.medium,
                )};
              `}
            >
              {translate('This action cannot be undone.')}
            </p>
          </>
        }
        actionButtonLabel={translate('Confirm and Delete')}
        actionButtonOnClick={dispatchDeleteExpense}
        actionButtonLoading={deletingExpense}
        actionButtonVariant="severe"
        topLevelError={topLevelError}
        isCancelButtonLink
        underline={false}
        cancelButtonOnClick={closePopup}
        cancelButtonLabel={translate('Cancel')}
      />
    </Popup>
  )
}

export default DeleteExpensePopup
